export const ageMethod = "age nearest";
export const gateway = "https://mcdougall-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/mcdougall";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJtY2RvdWdhbGwiLCJuYW1lIjoibWNkb3VnYWxsIiwiaWF0IjoxNzc5OTE5OTYwLCJleHAiOjE5Mzc3MDc5NjB9.mEQq3OGtimydLU_o38y9Au5lTDJAV1vm_jnX8fQbjlI";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"mcdougall.link.wawanesalife.com": {
		a: {
			approve_company: "EAST ONTARIO",
			approve_user: "link_mcdougall",
			brands: [
				"mcdougall.link.wawanesalife.com",
			],
			broker: "mcdougall",
			broker_formatted_name: "McDougall Insurance",
			email: "belleville@mcdougallinsurance.com",
			environment: "stable",
			environment_id: "stable",
			g4: "GTM-KQT2NH5",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "(800) 361-0941",
			photos: [
				"photo1.jpg",
				"photo2.jpg",
				"photo3.jpg",
				"photo4.jpg",
				"photo5.jpg",
				"photo6.jpg",
				"photo7.jpg",
				"photo8.jpg",
				"photo9.jpg",
			],
			privacyLink: "https://www.mcdougallinsurance.com/privacy-policy/",
			themeSwitcher: "show",
			website: "https://www.mcdougallinsurance.com/",
			scope: "mcdougall#branding#mcdougall.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "mcdougall.link.wawanesalife.com",
		},
		b: {
			approve_company: "EAST ONTARIO",
			approve_user: "link_mcdougall",
			brands: [
				"mcdougall.link.wawanesalife.com",
			],
			broker: "mcdougall",
			broker_formatted_name: "McDougall Insurance",
			email: "belleville@mcdougallinsurance.com",
			environment: "stable",
			environment_id: "stable",
			g4: "GTM-KQT2NH5",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "(800) 361-0941",
			photos: [
				"photo1.jpg",
				"photo2.jpg",
				"photo3.jpg",
				"photo4.jpg",
				"photo5.jpg",
				"photo6.jpg",
				"photo7.jpg",
				"photo8.jpg",
				"photo9.jpg",
			],
			privacyLink: "https://www.mcdougallinsurance.com/privacy-policy/",
			themeSwitcher: "show",
			website: "https://www.mcdougallinsurance.com/",
			scope: "mcdougall#branding#mcdougall.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "mcdougall.link.wawanesalife.com",
		},
	},
};

//updated on Wed May 27 2026 17:12:40 GMT-0500 (Central Daylight Time)
